import React, { useState} from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { useMutation } from '@apollo/client';
import { DELETE_STAFF_BY_STAFF_ID } from 'graphql/service';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ModalRemoveStaff = ({
  buttonIcon,
  buttonLabel,
  iconStyle,
  buttonStyle,
  name,
  staffId
}) => {

  const [isOpen, setIsOpen] = useState(false);

  const [deleteStaff, {loading}] = useMutation(DELETE_STAFF_BY_STAFF_ID,
    {
      onCompleted: (data) => {
        if(data.deleteStaff.id) {
          setIsOpen(false)
        } else {
          const content = 'Remove staff failed!'
          debouncedErrorMessage(content);
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )

  const handleRemove = () => {
    if(loading) return
    deleteStaff({
      variables: {
        staffId
      }
    })
  }

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      buttonIcon={buttonIcon}
      buttonLabel={buttonLabel}
      iconStyle={iconStyle}
      buttonStyle={buttonStyle}
      danger={true}
      className="modal-danger"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <div className='text'>{`Are you sure you want to remove ${name} from the staff list?`}</div>
        <Button
          danger
          onClick={() => setIsOpen(false)}
          additionalstyle={`
            width: 79px;
            margin-top: 24px;
            margin-right: 16px;
          `} 
        >
          Cancel
        </Button>
        <Button
          success
          onClick={handleRemove}
          data-loading={loading}
          additionalstyle={`
            width: 56px;
            margin-top: 24px;
          `}
        >
          {loading? null: 'Yes'}
        </Button>
      </Container>
    </MainModal>
  );
}

export default ModalRemoveStaff;
